import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeStocktakeUpdate } from '#/api/imsMgmt/receipts/stocktake/serializeStocktakeWrite';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/** PUT `/ims/stocktake/{id}`。全量 lines overwrite；body 含 updatedAt。 */
export async function updateStocktake(id, values) {
  const { data: raw } = await request.put(
    `/ims/stocktake/${id}`,
    serializeStocktakeUpdate(omitTopLevelId(values)),
  );
  return parseVer4DetailResponse(raw);
}
